import React from "react";

class Guests extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }


    render = () => {
        const guests = this.props.guests;

        const guestsBlock = guests.map((guest, index) => {
            return <tr>
                <th scope="row" className="text-center rea-guestCount">{index + 1}</th>
                { guest.middleName &&
                    <td className="rea-guestName">{guest.firstName} {guest.middleName} {guest.lastName}</td>
                }
                { !guest.middleName &&
                    <td className="rea-guestName">{guest.firstName} {guest.lastName}</td>
                }
                <td className="text-center rea-guestAge">{guest.age}</td>
            </tr>
        });

        return (
            <div className="rea-guestContainer rea-block-row">
                <div className="rea-block-12">
                    <div className="rea-sectionHeaders">Guest Information</div>
                </div>
                <div className="rea-block-12">
                    <div className="rea-bold">
                        The first and last names on your ticket must match your identification.
                    </div>
                    <div>
                        Please review the names below, and contact us if there are any discrepancies.
                    </div>
                </div>
                <div className="rea-block-12 rea-guestTable">
                    <table className="table table-striped table-bordered">
                        <thead className="tableHeader">
                        <tr>
                            <th scope="col" className="text-center rea-guestCount">Guest</th>
                            <th scope="col">Guest Name</th>
                            <th scope="col" className="text-center rea-guestAge">Age</th>
                        </tr>
                        </thead>
                        <tbody>
                        {guestsBlock}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default Guests;
